export const CHAIN_CONFIG = {
  chainId: 97,
  mode: 'native',
  native: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18
  },
  weth: {
    address: '0x3C7F689228Edd29c475316a58A42B4d8fC604649',
    symbol: 'WBNB',
    name: 'Wrapped BNB',
    decimals: 18
  },
  stable: {
    address: '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    symbol: 'BUSD',
    name: 'BUSD Token',
    decimals: 18
  },
  contracts: {
    multicall: '0x1f193bA67B67871b59e9C9a55f43c89e2c95E761',
    factory: '0x99D2B3a4aC61457345B7fBE669E6bC0CC3887709',
    initCodeHash: '0x0bf8a2ab7ce8aa0072c6560a2ea5638f1f4956771b2456d3fc9be023be2a9982',
    router: '0xD24FC2422Db48d912F7af10f5B5036Cf90910f16'
  },
  explorer: {
    name: 'BSCSCAN',
    url: 'https://testnet.bscscan.com'
  },
  menuLinks: [
    {
      label: 'About',
      url: '',
      icon: 'info'
    },
    {
      label: 'Docs',
      url: '',
      icon: 'book'
    },
    {
      label: 'Code',
      url: '',
      icon: 'code'
    },
    {
      label: 'Discord',
      url: '',
      icon: 'message'
    },
    {
      label: 'Analytics',
      url: '',
      icon: 'chart'
    }
  ],
  rpcUrl: process.env.REACT_APP_NETWORK_URL || 'https://data-seed-prebsc-1-s1.bnbchain.org:8545'
}
